import { z } from "zod";

import type { components } from "@/api/schema";

/**
 * Validation + inferred type for campaign create AND rename — both BE bodies are
 * `{ name: string }` (CreateCampaignRequest === UpdateCampaignRequest).
 */
export const campaignSchema = z.object({
  name: z.string().trim().min(1, "campaign:form.err_name_required"),
});

export type CampaignFormValues = z.infer<typeof campaignSchema>;

// Compile-time guard: form output must satisfy the BE request body.
type _AssertCreate = CampaignFormValues extends components["schemas"]["CreateCampaignRequest"]
  ? true
  : never;
type _AssertUpdate = CampaignFormValues extends components["schemas"]["UpdateCampaignRequest"]
  ? true
  : never;
const _create: _AssertCreate = true;
const _update: _AssertUpdate = true;
void _create;
void _update;
